import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

function LinePrimeFiltering() {
  const { control, watch } = useFormContext();
  const { t } = useTranslation();

  const firstStageEnabled = watch("linePrimeFilterFirstStageEnabled") ?? true;
  const secondStageEnabled =
    watch("linePrimeFilterSecondStageEnabled") ?? false;

  const validationRules = {
    firstStageClass: {
      required:
        firstStageEnabled
          ? t("projectinformation.err") || "This field is required"
          : false,
    },
    secondStageClass: {
      required:
        secondStageEnabled
          ? t("projectinformation.err") || "This field is required"
          : false,
    },
  };

  return (
    <Container component="main" sx={{ mb: 4, "min-width": "100%" }}>
      <Paper
        variant="outlined"
        sx={{ p: { xs: 2, md: "15px 24px 24px 24px" }, align: "center" }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Typography sx={{ textAlign: "center", fontSize: "38px", mb: "0px" }}>
            {t("linePrimeFiltering.title", { defaultValue: "Filtering" })}
          </Typography>
        </Box>
        <Box
          sx={{ mt: 2, display: "flex", flexDirection: "column", gap: "16px" }}
        >
          {/* First Stage */}
          <Box>
            <Controller
              name="linePrimeFilterFirstStageEnabled"
              control={control}
              render={({ field: { value, onChange } }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={value ?? true}
                      onChange={(e) => onChange(e.target.checked)}
                    />
                  }
                  label={t("linePrimeFiltering.firstStage", {
                    defaultValue: "First stage",
                  })}
                />
              )}
            />
            <Controller
              name="linePrimeFilterFirstStageClass"
              control={control}
              rules={validationRules.firstStageClass}
              render={({ field, fieldState: { error } }) => (
                <FormControl fullWidth disabled={!firstStageEnabled} error={!!error}>
                  <InputLabel
                    id="select-first-stage-label"
                    sx={{ color: "#373437" }}
                  >
                    {t("linePrimeFiltering.first", {
                      defaultValue: "First stage",
                    })}
                  </InputLabel>
                  <Select
                    {...field}
                    labelId="select-first-stage-label"
                    label={t("linePrimeFiltering.firstStage", {
                      defaultValue: "First stage",
                    })}
                    MenuProps={{ disableScrollLock: true }}
                    disablePortal
                  >
                    <MenuItem value="M5">ePM10 55% (M5)</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Box>

          {/* Second Stage */}
          <Box>
            <Controller
              name="linePrimeFilterSecondStageEnabled"
              control={control}
              render={({ field: { value, onChange } }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={value ?? false}
                      onChange={(e) => onChange(e.target.checked)}
                    />
                  }
                  label={t("linePrimeFiltering.secondStage", {
                    defaultValue: "Second stage",
                  })}
                />
              )}
            />
            <Controller
              name="linePrimeFilterSecondStageClass"
              control={control}
              rules={validationRules.secondStageClass}
              render={({ field, fieldState: { error } }) => (
                <FormControl
                  fullWidth
                  disabled={!secondStageEnabled}
                  error={!!error}
                >
                  <InputLabel
                    id="select-second-stage-label"
                    sx={{ color: "#373437" }}
                  >
                    {t("linePrimeFiltering.second", {
                      defaultValue: "Second stage",
                    })}
                  </InputLabel>
                  <Select
                    {...field}
                    labelId="select-second-stage-label"
                    label={t("linePrimeFiltering.second", {
                      defaultValue: "Second stage",
                    })}
                    MenuProps={{ disableScrollLock: true }}
                    disablePortal
                  >
                    <MenuItem value="F7">ePM1 50% (F7)</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
}

export default LinePrimeFiltering;
